<template>
  <div class="store-products-page">
    <div class="temp1"></div>
    <div v-if="isIframe" class="icon-wrapper">
      <v-icon class="v-icon" @click="onCloseIframe">mdi-close</v-icon>
    </div>
    <div class="store-products-content">
      <div class="store-products-header">
        <div class="store-products-heading">
          <h2>Your Wishlist by Shopdrop</h2>
        </div>
        <div class="header-actions">
          <v-btn v-if="!token" text @click="signIn">
            <span class="mr-2">Log In</span>
          </v-btn>

          <v-btn text v-if="token">
            <v-menu transition="slide-y-transition" offset-y offset-x bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" class="mr-2"
                  >Hello {{ name }}!</span
                >
              </template>
              <v-list>
                <v-list-item>
                  <v-list-item-title class="clickable" @click="logout"
                    >Log Out</v-list-item-title
                  >
                </v-list-item>
              </v-list>
            </v-menu>
          </v-btn>
        </div>
      </div>
      <div class="products">
        <div
          class="products-row"
          :class="{ 'products-row-small-screen': windowSize <= 600 }"
        >
          <div v-if="localMerchantProducts.length === 0">
            <div v-if="!token" class="no-items">
              <p class="notify">
                <span class="emphasize">SAVE</span> products<br />
                Get <span class="emphasize-1">DISCOUNTS</span> <br />
                All in <span class="emphasize">ONE</span> place
              </p>
              <span class="notify">Try Shopdrop now!</span>
              <div class="my-2">
                <v-btn @click="signIn" class="two-buttons" color="#ba22cc">
                  <span class="mr-2">Log In</span>
                </v-btn>
                <v-btn
                  @click="learnMore"
                  color="rgb(20,200,200)"
                  class="two-buttons"
                >
                  <span class="mr-2">Learn More</span>
                </v-btn>
              </div>
            </div>
          </div>
          <Card
            v-for="(product, i) in localMerchantProducts"
            :cardData="product"
            :key="i"
            :isIframe="true"
            @delete="onRemoveProduct"
            class="card"
          />
        </div>
      </div>
      <div class="all-products-wrapper" v-if="localMerchantProducts.length > 0">
        <div class="store-products-header">
          <div class="store-products-heading">
            <h4>All Saved Products</h4>
          </div>
        </div>
        <div class="products" v-if="token">
          <div class="show-all">
            <v-btn text @click="showAll">
              <span class="mr-2">Show all</span>
            </v-btn>
          </div>
          <div
            class="products-row"
            :class="{ 'products-row-small-screen': windowSize <= 500 }"
          >
            <Card
              v-for="(product, i) in allProducts"
              :cardData="product"
              :key="i"
              :isIframe="true"
              @delete="onRemoveProduct"
              class="card"
            />
          </div>
        </div>
        <div class="no-items all-products" v-else>
          <p class="notify">
            <span class="emphasize">SAVE</span> products<br />
            Get <span class="emphasize-1">DISCOUNTS</span> <br />
            All in <span class="emphasize">ONE</span> place
          </p>
          <span class="notify">Try Shopdrop now!</span>
          <div class="my-2">
            <v-btn @click="signIn" class="two-buttons" color="#ba22cc">
              <span class="mr-2">Log In</span>
            </v-btn>
            <v-btn
              @click="learnMore"
              color="rgb(20,200,200)"
              class="two-buttons"
            >
              <span class="mr-2">Learn More</span>
            </v-btn>
          </div>
        </div>
      </div>
    </div>

    <modal
      title="Delete Product"
      :showModal="isDeleteProductModalOn"
      ok="Delete"
      close="Cancel"
      @ok="onOkDeleteProductModal"
      @close="onCloseDeleteProductModal"
    >
      <div slot="content">
        <v-card-subtitle
          >Are you sure you want to delete
          {{ productToDelete.name }}?</v-card-subtitle
        >
      </div>
    </modal>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import Card from "./Card";
import Modal from "./Modal";
import keyBy from "lodash.keyby";

export default {
  name: "StoreWishlist",

  components: {
    Card,
    Modal,
  },
  data() {
    return {
      windowSize: window.innerWidth,
      productToDelete: {},
      isDeleteProductModalOn: false,
    };
  },
  computed: {
    ...mapGetters(["products", "token", "isIframe", "name"]),
    ...mapState(["iframeProducts", "iframeParentUrl"]),
    localMerchantProducts() {
      if (this.token) {
        return this.products.filter(
          (product) => product.merchantUrl === this.iframeParentUrl
        );
      }
      return this.iframeProducts;
    },
    allProducts() {
      if (this.token) {
        return this.products.filter(
          (product) => product.merchantUrl !== this.iframeParentUrl
        );
      }
      return this.iframeProducts;
    },
  },
  methods: {
    ...mapActions([
      "removeProduct",
      "addBanner",
      "logout",
      "removeIframeProduct",
    ]),
    onCloseIframe() {
      parent.postMessage(
        {
          message: "closeIframe",
          items: keyBy(this.localMerchantProducts, "shopifyVariantId"),
        },
        "*"
      );
    },

    showAll() {
      window.open("https://getshopdrop.com/products");
    },

    async removeProductFromListId() {
      this.removeIframeProduct(this.productToDelete.shopifyVariantId);
      parent.postMessage(
        { message: "removeProduct", product: this.productToDelete },
        "*"
      );
    },
    async onOkDeleteProductModal() {
      try {
        await this.removeProductFromListId();
        if (this.token) {
          await this.removeProduct(this.productToDelete._id);
        }
        const banner = {
          type: "success",
          text: "Product has been removed.",
          dismiss: true,
        };
        this.addBanner(banner);
        this.isDeleteProductModalOn = false;
        this.productToDelete = {};
      } catch {
        const banner = {
          type: "error",
          text: "Oops something went wrong..please try again.",
          dismiss: true,
        };
        this.addBanner(banner);
        this.isDeleteProductModalOn = false;
        this.productToDelete = {};
      }
    },

    async onCloseDeleteProductModal() {
      this.isDeleteProductModalOn = false;
      this.productToDelete = {};
    },

    onRemoveProduct(product) {
      this.isDeleteProductModalOn = true;
      this.productToDelete = product.product;
    },
    signIn() {
      this.$router.push({ name: "signin" });
    },
    learnMore() {
      window.open("http://www.getshopdrop.com");
    },
  },
};
</script>

<style scoped>
.store-products-page {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.store-products-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.store-products-header {
  position: relative;
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  padding-bottom: 60px;
  padding-right: 60px;
  padding-left: 60px;
}

.store-products-heading {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 20;
  background: white;
  height: 60px;
  border-bottom: 1px solid #e6e6ed;
}

.header-actions {
  display: flex;
  align-items: center;
  height: 60px;
  width: 100%;
  border-bottom: 1px solid #e6e6ed;
  justify-content: flex-end;
}

.products {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.no-items {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  padding: 10px;
}

.products-row-small-screen {
  justify-content: center !important;
}
.products-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
}

.card {
  flex: 1 0 25%;
  margin-right: 0.5%;
  margin-left: 0.5%;
  margin-top: 1%;
  margin-bottom: 1%;
  max-width: 320px;
  display: flex;
  flex-direction: column;
}

.spacer {
  max-width: 400px;
  margin: 0 0 24px 18px;
  padding: 20px 24px 24px 24px;
}
.form {
  padding: 5%;
}
.icon-wrapper {
  align-self: flex-end;
  margin-right: 31px;
  margin-top: 31px;
}
.show-all {
  display: flex;
  align-self: flex-end;
  padding-right: 100px;
}
.two-buttons {
  margin: 10px;
}
.temp1 {
  background: url(../../images/wallpaper/items-background.jpg);
  opacity: 0.04;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
}
.emphasize {
  font: 500;
  color: rgb(20, 200, 200);
}
.emphasize-1 {
  font: 500;
  color: #ba22cc;
}
.notify {
  font-family: Helvetica Neue;
  font-size: 30px;
  font-weight: 300;
}
.all-products-wrapper {
  width: 100%;
}
</style>
